import { ApiConstants } from './../../../shared/services/api-constants.service';
import { ClubsService } from './../../clubs/clubs.service';
import { REGEX } from './../../../app.validators';
import { Component, Injector } from '@angular/core';
import { AbstractControl, Validators } from '@angular/forms';
import { BaseFormComponent } from 'src/app/shared/components/base-form-component/base-form-component';
import { User } from 'src/app/shared/models/user.model';
import { UsersService } from 'src/app/shared/services/users.service';
import { Club } from '../../clubs/club.model';

@Component({
    selector: 'ng-users',
    templateUrl: 'users-form.component.html'
})
export class UsersFormComponent extends BaseFormComponent<User> {

    public clubs:Array<Club>;
    public roles:Array<any>;
    
    constructor(
        public injector: Injector, 
        public constantServ: ApiConstants,
        public usersServ: UsersService,
        public clubsServ:ClubsService
    ){
        super(injector, 'userr', '/admin/users', User.fromJsonToObject, usersServ);
    }

    protected buildForm(): void {

        this.objectForm = this.formBuilder.group({
            name: this.formBuilder.control(null, [Validators.required]),
            email: this.formBuilder.control(null, [Validators.required, Validators.pattern(REGEX.email)]),
            phone: this.formBuilder.control(null, [Validators.required, Validators.minLength(9), Validators.maxLength(14), Validators.pattern(REGEX.numberPattern)]),
            address: this.formBuilder.control(null, [Validators.required]),
            nuit: this.formBuilder.control(null, [Validators.required, Validators.minLength(9), Validators.maxLength(9), Validators.pattern(REGEX.numberPatternNoComma)]),
            bi: this.formBuilder.control(null, [Validators.required, Validators.minLength(13), Validators.maxLength(13)]),
            responsible_name: this.formBuilder.control(null),
            responsible_phone: this.formBuilder.control(null),
            clubs_id: this.formBuilder.control(null),
            role_id: this.formBuilder.control(null, [Validators.required]),
            password: this.formBuilder.control(null, [Validators.minLength(8)]),
            confirmPassword: this.formBuilder.control(null, [Validators.minLength(8)]),
            id: this.formBuilder.control(null),
        }, { validator: UsersFormComponent.equalsTo })

    }

    // Verificando passwords iguais
    static equalsTo(group: AbstractControl): { [key: string]: boolean } {
        const password = group.get('password')
        const pwdConfirm = group.get('confirmPassword')

        if (!password || !pwdConfirm) {
            return undefined
        }

        if (password.value !== pwdConfirm.value) {
            return { passwordsNotMatch: true }
        }


        return undefined
    }

    protected initChildProprieties(): void { }

    protected initChildMethods(): void { 
        this.loadConstants();
        this.clubsServ.getAll().subscribe(clubs=>this.clubs=clubs)
    }

    loadConstants() {
        const role=JSON.parse(localStorage.getItem("constants"));

        if(!!role && role.roles){
            this.roles=role.roles;
        }else{
            this.formSubscription.add(this.constantServ.getAllRoles().subscribe(roles => {
                this.roles=roles;
            }))
        }
    }
    
}